<div class="sb-step">
  <div class="sb-step__main">
    <segment-information-form />
  </div>

  <app-segment-information-tips-card class="sb-step__aside" header="Tips" [tips]="visibleTips" [divide]="true" />
</div>
